export const hlsPlayerConfig = {
  file: {
    hlsOptions: {
      xhrSetup: (xhr: XMLHttpRequest) => {
        xhr.withCredentials = true;
      }
    }
  }
};
